module.exports = __webpack_public_path__ + "static/media/selected.43294d84.png";